const customRulesCurrencyList = {
  zenit: ['RUB', 'KZT', 'UAH', 'USD', 'EUR', 'TMT', 'BRL', 'IRR', 'PRB'],
  zenbet: ['USD', 'EUR', 'BRL', 'IRR', 'RUB', 'KZT', 'UAH', 'TMT', 'PRB'],
  cupis: ['RUB'],
}

const customRulesCurrencyValues = {
  "BRL": [9, 18, 35, 70, 145, 215, 355, 710, 1100, 2150, 3550],
  "EUR": [1, 3, 6, 12, 23, 34, 55, 110, 170, 335, 560],
  "IRR": [75000, 150000, 300000, 570000, 1150000, 1700000, 2900000, 5750000, 8600000, 17200000, 28700000],
  "KZT": [750, 1500, 3000, 6000, 12000, 18000, 30000, 60000, 80000, 175000, 290000],
  "MDL": [30, 60, 120, 250, 500, 730, 1220, 2450, 3700, 7350, 12250],
  "PRB": [30, 55, 110, 220, 440, 650, 1100, 2200, 3300, 6600, 11000],
  "RUB": [100, 250, 500, 1000, 2000, 3000, 5000, 10000, 15000, 30000, 50000],
  "TMT": [7, 13, 25, 50, 100, 145, 240, 475, 715, 1430, 2380],
  "UAH": [50, 100, 200, 400, 800, 1100, 1900, 3800, 5600, 11200, 18700],
  "USD": [2, 4, 7, 14, 28, 40, 70, 140, 200, 410, 680],
}

export {
  customRulesCurrencyList,
  customRulesCurrencyValues
}